import { EmptyValuePlaceholder } from "@/components/ui"
import { formatDate } from '@/utils/formatters'

export default ({item}) => {
  return(
    <div className="card bg-primary-200 w-full md:w-[calc(50%-0.5rem)]">
      <div className="card-body p-4 bg-base-200">
        <div className="grid grid-cols-2 gap-2">
          <div className="text-sm font-medium text-gray-600">Prestataire</div>
          <div>{item.prestataire?.nom_complet || <EmptyValuePlaceholder />}</div>
          <div className="text-sm font-medium text-gray-600">Date</div>
          <div>{formatDate(item.date_prestation) || <EmptyValuePlaceholder />}</div>
          <div className="text-sm font-medium text-gray-600">Détails</div>
          <div><EmptyValuePlaceholder value={item.entretien_type_description || item.entretien_type_nom} /></div>
        </div>
      </div>
    </div>
  )
}